module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-steak@3x-2d6f61f9a4bd707287be84034fd8170d.png";